export interface DelenProgress {
    readonly total: number | null;
    readonly done: number;
    readonly failed: number;
    readonly open: number;
    readonly slow: boolean;
}

export interface MeldingState {
    readonly key: string;
    readonly params: Record<string, number>;
    readonly kind: 'busy' | 'success' | 'error';
    readonly withLink: boolean;
}

export function toMeldingState(progress: DelenProgress): MeldingState {
    const total: number | null = progress.total;

    if (total === null) {
        return { key: 'busy', params: {}, kind: 'busy', withLink: false };
    }

    const params: Record<string, number> = { total, done: progress.done, failed: progress.failed };

    if (progress.open > 0) {
        return { key: openKey(progress, total), params, kind: 'busy', withLink: false };
    }

    return { key: settledKey(progress, total), params, kind: settledKind(progress), withLink: true };
}

function openKey(progress: DelenProgress, total: number): string {
    if (progress.slow) {
        return total > 1 ? 'progress-slow' : 'progress-slow-single';
    }

    if (progress.done > 0) {
        return 'progress';
    }

    return total > 1 ? 'busy-multi' : 'busy';
}

function settledKey(progress: DelenProgress, total: number): string {
    if (progress.failed === 0) {
        return total > 1 ? 'done-multi' : 'done-single';
    }

    if (progress.done === 0) {
        return total > 1 ? 'all-failed-multi' : 'all-failed-single';
    }

    return 'partial-failed';
}

function settledKind(progress: DelenProgress): 'success' | 'error' {
    return progress.failed === 0 ? 'success' : 'error';
}
